import React from 'react';
export const XTwitterIcon = (props) => {
    return (
        <svg width="1em" {...props} height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.6336 2H16.0934L10.7195 8.14206L17.0415 16.5H12.0914L8.21431 11.4309L3.77804 16.5H1.31677L7.06471 9.93038L1 2H6.07575L9.58029 6.63331L13.6336 2ZM12.7703 15.0277H14.1333L5.33512 3.39498H3.87246L12.7703 15.0277Z"
                fill="white"
            />
        </svg>
    );
};
